import { Box, Typography } from '@mui/material';
import { getIn } from 'formik';
import { TooltipText } from '../inputComponents/TooltipText';
import { InputComponent } from '../inputComponents/InputComponent';

import '../../pages/AssignPromotion/AssignPromotionPage.css';

interface LuckyNumbersBatchDetailsProps {
    formik?: any;
}

function LuckyNumbersBatchDetails({
    formik,
}: LuckyNumbersBatchDetailsProps) {

    return (
        <Box className='batch-details-box'>
            <Box sx={{ ml: '5px' }}>
                <TooltipText
                    text='Batch Details'
                    textVariant='h4'
                    tooltip={
                        <Typography variant='body2'>
                            Select a batch size and amount per batch to generate lucky numbers.
                        </Typography>
                    }
                />
                <Typography className='typography-style' variant='body1'>
                    Specify the batch size and amount per batch.
                </Typography>
            </Box>

            <Box
                className='batch-details-field-box'
            >
                <InputComponent
                    formik={formik}
                    formikLabel='tempParams.luckyNumbersBatchSize'
                    inputValue={getIn(formik.values, 'tempParams.luckyNumbersBatchSize', '')}
                    label='Lucky Number Batch Size'
                    placeholder='Enter lucky number batch size'
                />
                <InputComponent
                    formik={formik}
                    formikLabel='tempParams.luckyNumbersBatchAmount'
                    inputValue={getIn(formik.values, 'tempParams.luckyNumbersBatchAmount', '')}
                    label='Lucky Number Batch Amount'
                    placeholder='Lucky Number Batch Amount'
                />
            </Box>
        </Box>
    );
}

export { LuckyNumbersBatchDetails };
